import React, { useState } from "react";
import { Link, Box, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import PointsLock from "./points-lock";
import NotificationBar from "../shared/notification-bar";
import { createStyles } from "@mui/styles";

const styles = (theme) => createStyles({
  root: {
    height: 140,
    background: "#fff",
    borderRadius: "0 0 0 60px",
    boxShadow: "0px 0px 9px 5px rgba(0,0,0,0.1)",
    position: "absolute",
    width: "100%",
  },
  icons: {
    display: "flex",
  },
  previewImage: {
    objectFit: "cover",
    maxHeight: 50,
    maxWidth: 40,
    marginTop: 70,
    marginLeft: 30,
  },
  lectionNumber: {
    color: "#9AA6AC",
    marginTop: 70,
    fontSize: 12,
  },
  lectionName: {
    fontWeight: "bold",
    fontSize: 14,
    color: "#383838",
  },
  disabledLectionName: {
    fontWeight: "bold",
    fontSize: 14,
    color: "#707070",
  },
  descriptionContainer: {
    maxWidth: 190,
  },
});

const PreviewCard = ({
  classes,
  index,
  title,
  clickHandler,
  iconUrl,
  disabledIconUrl,
  startDate,
  startDateDistance,
  locked,
  finished,
  started,
  readableDuration,
  credits,
}) => {
  const showAlert = (e) => {
    e.preventDefault();
    setErrorMessage("Dieser Kurs ist noch nicht freigeschaltet");
  };

  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const available = started && !locked;
  const usedClickHandler = available ? clickHandler : showAlert;
  const lectionNameClass = available
    ? classes.lectionName
    : classes.disabledLectionName;
  const actualIconUrl = available ? iconUrl : disabledIconUrl;

  const zIndex = 99;
  let firstMargin = { marginTop: "" };
  if (index === 0) {
    firstMargin = { marginTop: "-15px" };
  }

  return (
    <>
      {errorMessage && <NotificationBar errorMessage={errorMessage} />}
      <Box
        className={classes.root}
        style={{
          top: index * 90 + 70,
          zIndex: zIndex - index,
          marginTop: "-15px",
        }}
      >
        <Link
          href="#"
          onClick={usedClickHandler}
          style={{ textDecoration: "none" }}
        >
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" alignItems="center">
              <img
                src={actualIconUrl}
                className={classes.previewImage}
                alt="preview"
              />
            </Box>

            <Box
              ml={2}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              className={classes.descriptionContainer}
              style={firstMargin}
              alignItems="flex-start"
            >
              <Typography
                variant="body2"
                component="p"
                className={classes.lectionNumber}
              >
                Lektion {index + 1}
              </Typography>
              <Typography
                variant="h6"
                component="p"
                align="left"
                className={lectionNameClass}
              >
                {title}
              </Typography>
            </Box>
            <PointsLock
              startDate={startDate}
              startDateDistance={startDateDistance}
              locked={locked}
              finished={finished}
              credits={credits}
            />
          </Box>
        </Link>
      </Box>
    </>
  );
};

export default withStyles(styles)(PreviewCard);
